"use strict";

exports.__esModule = true;
exports.scrollHandler = exports.mouseMoveHandler = exports.mouseLeaveHandler = void 0;
var _tooltipReducer = require("./tooltipReducer");
var mouseMoveHandler = exports.mouseMoveHandler = function mouseMoveHandler(tooltipDispatcher) {
  return function (event) {
    tooltipDispatcher({
      type: _tooltipReducer.TOOLTIP_ACTION_MOUSE_MOVE,
      payload: {
        boundingClientRect: event.currentTarget.getBoundingClientRect(),
        clientX: event.clientX,
        clientY: event.clientY
      }
    });
  };
};
var scrollHandler = exports.scrollHandler = function scrollHandler(tooltipDispatcher) {
  return function (event) {
    tooltipDispatcher({
      type: _tooltipReducer.TOOLTIP_ACTION_SCROLL,
      payload: {
        scrollLeft: event.currentTarget.scrollLeft
      }
    });
  };
};
var mouseLeaveHandler = exports.mouseLeaveHandler = function mouseLeaveHandler(tooltipDispatcher, forceLeave) {
  return function (event) {
    var _event$currentTarget$ = event.currentTarget.getBoundingClientRect(),
      left = _event$currentTarget$.left,
      width = _event$currentTarget$.width,
      top = _event$currentTarget$.top,
      height = _event$currentTarget$.height;
    if (!(event.clientX > Math.floor(left) && event.clientX < Math.floor(left + width) && event.clientY > Math.floor(top) && event.clientY < Math.floor(top + height)) || forceLeave) {
      tooltipDispatcher({
        type: _tooltipReducer.TOOLTIP_ACTION_MOUSE_LEAVE
      });
    }
  };
};